import { useEffect, useMemo } from 'react';

import { Replacer } from '../addons/replacer/replacer-main';
import Static from '../canvases/static';

export default function useReplacer(manager: Static | undefined) {
  const replacer = useMemo(() => new Replacer(), []);
  useEffect(() => {
    if (!manager) return;
    replacer.init(manager);
  }, [manager, replacer]);
  return replacer;
}
